import { CurrencyPipe, DatePipe } from "@angular/common";
import { Component, ElementRef, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import Swal from "sweetalert2";
import { environment } from "src/environments/environment";
//Componentes
import { PaymentFormComponent } from "../../payment-form/payment-form.component";
//Services
import { PacientesService } from "src/app/core/services/paciente.service";
import { PagosPaquetesService } from "src/app/core/services/pagos.paquetes.service";
import { ServiciosService } from "src/app/core/services/servicios.service";
import { PaquetesAdquiridosService } from "src/app/core/services/paquetes-adquiridos.service";

@Component({
  selector: "app-comprar-paquetes",
  standalone: true,
  imports: [DatePipe, CurrencyPipe, PaymentFormComponent],
  templateUrl: "./comprar-paquetes.component.html",
  styleUrl: "./comprar-paquetes.component.scss",
})
export class ComprarPaquetesComponent {
  @ViewChild(PaymentFormComponent) paymentFormComponent: PaymentFormComponent;

  idPaquete: string;
  datosPaciente: any;
  datosPaquete: any;
  date: Date = new Date();
  userLocal: boolean = true;
  //Payment

  amountInCents = 0; // Ejemplo de monto
  reference = "";
  signature = "";

  constructor(
    private route: ActivatedRoute,
    private __pacientesService: PacientesService,
    private __pagosPaquetesService: PagosPaquetesService,
    private __serviciosService: ServiciosService,
    private __paquetesAdquiridosService: PaquetesAdquiridosService,
    private router: Router
  ) {}
  ngOnInit(): void {
    this.idPaquete = this.route.snapshot.params["idPaquete"];
    if (this.idPaquete) {
      this.getPaquete(this.idPaquete);
    }
    const currentUser = localStorage.getItem("currentPatient");
    if (currentUser) {
      this.userLocal = JSON.parse(currentUser).local;
      this.getPaciente(JSON.parse(currentUser).userId);
    }
  }

  /**
   *
   * @param idPaciente
   */
  getPaciente(idPaciente: string) {
    this.__pacientesService.getDocument(idPaciente).then((res: any) => {
      this.datosPaciente = res;
      console.log("datosPaciente", this.datosPaciente);
    });
  }

  /**
   *
   * @param idPaquete
   */
  getPaquete(idPaquete: string) {
    this.__serviciosService.getDocument(idPaquete).then((res: any) => {
      this.datosPaquete = res;
      console.log("datosPaquete", this.datosPaquete);
    });
  }

  /**
   *
   */
  async comprarPaquete() {
    const confirm = await Swal.fire({
      title: "¿Sera redirigido para continuar con la compra?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#f46a6a",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
    });

    if (confirm.value) {
      const valor = this.userLocal
        ? this.datosPaquete.valorCop
        : this.datosPaquete.valorUsd;
      const moneda = this.userLocal ? "COP" : "USD";

      //Insertar paquetes_adquiridos
      const dataPaquete = {
        idPaciente: this.datosPaciente.$id,
        idServicio: this.datosPaquete.$id,
        citasRestantes: this.datosPaquete.cantidad_citas,
        fCompra: new Date(),
        valorPagado: valor,
        monedaPagado: moneda,
        activo: false,
      };
      // console.log("datosPaquete", this.datosPaquete);

      try {
        const paqueteAdquirido =
          await this.__paquetesAdquiridosService.createDocument(dataPaquete);
        // console.log("paqueteAdquirido", paqueteAdquirido);
        const dataPagoPaquete = {
          idPaquetesAdquiridos: paqueteAdquirido.$id,
          IdEstadoPago: "creada",
          referencia: "p_" + paqueteAdquirido.$id,
          fechaPago: new Date(),
          valor: valor,
          descripcion: "Compra Paquete",
        };
        const pagoPaquete = await this.__pagosPaquetesService.createDocument(
          dataPagoPaquete
        );
        // console.log("pagoPaquete", pagoPaquete);
        this.callApiWompi("p_" + paqueteAdquirido.$id);
      } catch (error) {
        console.error("error creando pago ", error);
      }
    }
  }

  /**
   * Llama a la API de Wompi
   */
  async callApiWompi(idPago: string) {
    this.paymentFormComponent.signature = await this.generateHash(idPago);
    this.paymentFormComponent.amountInCents = this.userLocal
      ? this.datosPaquete.valorCop
      : this.datosPaquete.valorUsd;
    this.paymentFormComponent.reference = idPago;
    if (this.paymentFormComponent) {
      this.paymentFormComponent.submitPayment();
      this.router.navigate(["/"]);
    }
  }

  /**
   *
   * @param idPago
   * @returns
   */
  async generateHash(idPago: string) {
    const valor = this.userLocal
      ? this.datosPaquete.valorCop
      : this.datosPaquete.valorUsd;
    const cadenaConcatenada =
      idPago + valor * 100 + "COP" + environment.wompi.testIntegrity;
    console.log(cadenaConcatenada);
    //Ejemplo
    const encondedText = new TextEncoder().encode(cadenaConcatenada);
    const hashBuffer = await crypto.subtle.digest("SHA-256", encondedText);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
      .map((b) => b.toString(16).padStart(2, "0"))
      .join(""); // "37c8407747e595535433ef8f6a811d853cd943046624a0ec04662b17bbf33bf5"
    return hashHex;
  }
}
